/* jshint esversion: 6 */
/* global $ */

const WOW = require('wow.js');

try {
  window.wow = new WOW({
    live: true
  });
  $(document).ready(function() {
    window.wow.init();

  });
} catch (err) {
  console.log(err);
}


function limitText(limitField, limitCount, limitNum) {
  if (limitField.val().length > limitNum) {
    limitField.val(limitField.val().substring(0, limitNum));
  } else {
    $('#chars_left').text(limitNum - limitField.val().length);
  }
}

window.limitText = function(limitField, limitCount, limitNum) {
  if (limitField.val().length > limitNum) {
    limitField.val(limitField.val().substring(0, limitNum));
  } else {
    $('#chars_left').text(limitNum - limitField.val().length);
  }
};

window.trackGtmEvent = function(action, category, label, value = null, info = null) {
  window.dataLayer = window.dataLayer || [];
  let dataToPush = {
    event: action,
    event_category: category,
    event_label: label,
    value: value
    // info: info
  };
  console.log('DataLayer debug', info,dataToPush);
  window.dataLayer.push(dataToPush);
};

window.onElementVisible = function(selector, callback, threshold = 0.3) {
  const seen = new WeakSet();

  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (
        entry.isIntersecting &&
        entry.intersectionRatio >= threshold &&
        !seen.has(entry.target)
      ) {
        seen.add(entry.target);
        callback(entry.target);
        observer.unobserve(entry.target);
      }
    }
  }, { threshold });

  const tryObserve = (el) => {
    if (!seen.has(el)) observer.observe(el);
  };

  document.querySelectorAll(selector).forEach(tryObserve);

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          if (node.matches?.(selector)) tryObserve(node);
          node.querySelectorAll?.(selector).forEach(tryObserve);
        }
      });
    }
  }).observe(document.body, { childList: true, subtree: true });
};


window.mobilecheck = function() {
  var check = false;
  (function(a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

window.agenda = function(options) {
  var obj = {
    initialize: function(options) {
      this.options = $.extend({}, options);
      obj.initWidgetSettings();
    },

    initWidgetSettings: function() {
      $('.agenda-day').click(function(event) {
        event.preventDefault();
        obj.selectDay($(this).attr('data-day'));
      });
    },

    selectDay: function(day) {
      $.ajax({
        type: 'POST',
        url: '/index.php?section=widgets&screen=agenda',
        data: { day: day },
        success: function(data) {
          $('.agenda').replaceWith(data);
          agenda();
        }
      });
    }
  };

  obj.initialize(options);
  return obj;
};

window.best_of_today = function(options) {
  var obj = {
    initialize: function(options) {
      this.options = $.extend({}, options);
      obj.initWidgetSettings();
    },

    initWidgetSettings: function() {
      $('.best_important').click(function(event) {
        event.preventDefault();
        $('.best_read').removeClass('selected');
        obj.doRefresh($(this).attr('data-article'), $(this).attr('data-pos'), 'important');
      });
      $('.best_read').click(function(event) {
        event.preventDefault();
        $('.best_important').removeClass('selected');
        obj.doRefresh($(this).attr('data-article'), $(this).attr('data-pos'), 'read');
      });
    },

    doRefresh: function(widget_id, position, type) {
      $.ajax({
        type: 'POST',
        url: '/index.php?section=widgets&screen=first',
        data: { widget_id: widget_id, pos: position, type: type },
        success: function(data) {
          var rootElem = position === 'hp' ? $('.statistics.best-of-today') : $('.news-block.best-of-today-container');
          rootElem.replaceWith(data);
          best_of_today();
          if (typeof lazyLoadInstance != 'undefined' && lazyLoadInstance) {
            lazyLoadInstance.update();
          }
        }
      });
    }
  };

  obj.initialize(options);
  return obj;
};


_gspQ.push(function() {
  const versionWidget = window.widgetsVersionId || '26';
  if (document.querySelectorAll('[data-widgetId]').length > 0) {
    requestAnimationFrame(function() {
      $.getScript('/plugins/widgets/bundle.js?v=' + versionWidget, function() {
      });
    });

  }


});

try {
  let jquery = require('jquery');
  window.$ = window.jQuery = jquery;
} catch (e) {
  // debugger
}

$(document).ready(function() {
  gspDebug('Init _gspQ document ready (jQuery loaded');
  _gspQ.push = function(item) {
    item();
  };
  if (window._gspQ.length > 0) {
    console.log('Init _gspQ found');
    window._gspQ.map(function(item) {
      item();
    });
    window._gspQ.length = 0;
  } else {
    console.log('No _gspQ entries');
  }
  requestAnimationFrame(() => {
    document.body.classList.remove('preload');
  });
});

document.addEventListener('DOMContentLoaded', function() {
  // Select all elements with the class 'rotate-180'
  var elements = document.querySelectorAll('.rotate-180');

  // Function to remove the 'rotate-180' class
  var removeClass = function() {
    this.classList.remove('rotate-180');
  };

  // Add event listeners to each element
  elements.forEach(function(element) {
    // element.addEventListener('touchstart', removeClass);
    // element.addEventListener('touchmove', removeClass);
    // element.addEventListener('touchend', removeClass);
  });
});


window.handlePolls = function() {
  console.log('Init handle polls');
  if (getCookie('answered_polls')) {
    $.each($.parseJSON(decodeURIComponent(getCookie('answered_polls'))), function(index, value) {
      var poll_id = value.split('-')[0];
      vote = value.split('-')[1];

      var noAnswers = $('.poll[data-poll-id="' + poll_id + '"][class*="no-answers"]');
      if (noAnswers.length && noAnswers.data().pollId == poll_id) {
        noAnswers.hide();
      }

      var answers = $('.poll[data-poll-id="' + poll_id + '"][class*="with-answers"]');
      if (answers.length && answers.data().pollId == poll_id) {
        answers.show();
      }

      $('.poll-option[data-selected-option-id=' + vote + ']')
        .removeClass('not-voted')
        .addClass('voted');
    });
  }
};

window.GspModal = function(settings) {
  var obj = {
    settings: {}, init: function(settings) {
      this.settings = settings;
    }, render: function() {
      $('<div class="modal-wrapper"/>').appendTo('body');
      var messagetText = getCommentWarningMessage($('#comm_warning_version').val());
      $('<div class="modal" id="gsp-modal">' + '<div class="modal-dialog">' + '<div class="modal-dialog__body">' + messagetText + '</div><div class="modal-dialog__footer">' + '<button type="button" id="modal-ok">Public comentariul în forma actuală</button>' + '<button type="button"  id="modal-cancel">Vreau să imi verific comentariul</button>' + '</div>' + '</modal>').appendTo('body');

      $('.modal-wrapper').on('click', this.handleClickOnBack.bind(this));
      $('#modal-ok').on('click', this.handleOk.bind(this));
      $('#modal-cancel').on('click', this.handleCancel.bind(this));
    }, handleOk: function() {
      this.settings.onOk.call();
      this.destroy();
    }, handleCancel: function() {
      this.settings.onCancel.call();
      this.destroy();
    }, handleClickOnBack: function(e) {
      e.preventDefault();
    }, destroy: function() {
      //off la efents
      $('.modal-wrapper').remove();
      $('#gsp-modal').remove();
    }
  };

  obj.init(settings);
  return obj;
};

window.socialShare = function(type, width, height, e) {
  var winTop = screen.height / 2 - height / 2;
  var winLeft = screen.width / 2 - width / 2;
  window.open(type, 'sharer', 'toolbar=0,status=0,width=580, left=' + winLeft + ', top=' + winTop + ', height=325');
};

window.deleteCookie = function(name, path, domain) {
  if (setCookie(name)) {
    document.cookie = name + '=' + (path ? ';path=' + path : '') + (domain ? ';domain=' + domain : '') + ';expires=Thu, 01 Jan 1970 00:00:01 GMT';
  }
};
window.setCookie = function(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = 'expires=' + d.toGMTString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
};

window.getCookie = function(cname) {
  var name = cname + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1);
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
  }
  return '';
};

let votedPolls = {};
_gspQ.push(function() {
  $('.page-select').one('blur change', function(event) {
    document.location.href = $(this).val();
  });
  agenda();
  best_of_today();

  $('.poll').on('click', '.poll-option', function(ev) {
    ev.preventDefault();
    var item_id = $(this).data().id;
    var poll_id = $(this).data().pollId;
    if (votedPolls[poll_id] === true) {
      return;
    }
    votedPolls[poll_id] = true;
    $.ajax({
      method: 'POST', url: '/index.php?section=poll&screen=vote', data: { item_id: item_id }
    }).done(function(msg) {
      let answers = $('.poll[data-poll-id="' + poll_id + '"][class*="with-answers"]');
      let questions = $('.poll[data-poll-id="' + poll_id + '"][class*="no-answers"]');

      answers.replaceWith(msg);
      questions.css('display', 'none');
      answers.css('display', 'block');
    });
  });

  $('.reply').on('click', function() {
    $('#objectParinte').val($(this).data('id'));
  });

  $('.searchdv').val('src');

  $('.share-button.facebook, .share-button.whatsapp').click(function(ev) {
    // debugger;
    ev.preventDefault();
    var url = $(this).attr('href');
    socialShare(url, 580, 350);
  });
});

if (!window.mobilecheck()) {
  _gspQ.push(function() {
    var stagesIds = [];
    $('.tournament-stage').each(function(i, item) {
      if ($(item).is(':hidden') === false) {
        stagesIds.push($(item).data('tournamentstageid'));
      }
    });
    if (stagesIds.length > 0) {
      $.ajax({
        type: 'POST',
        url: '/plugins/smp-w/ranking.php',
        data: { stages: stagesIds },
        dataType: 'json',
        cache: false,
        success: function(data) {
          $.each(data, function(stageId, dataJson) {
            standingGrid = $('[data-tournamentstageid="' + stageId + '"]');
            standingGrid.html(dataJson.standings);
            standingGrid
              .parent()
              .parent()
              .find('.short-stats')
              .attr('href', dataJson.url);
            if (typeof lazyLoadInstance != 'undefined' && lazyLoadInstance) {
              lazyLoadInstance.update();
            }
          });
        }
      });
    }
  });
}

_gspQ.push(function() {
  $('.reply-like-report .reply').on('click', function() {
    $('#objectParinte').val($(this).data('id'));
  });

  $('#comentariu_field').keydown(function() {
    limitText($('#comentariu_field'), parseInt($('#chars_left').text()), 1500);
  });

  $('.sendtoFb').click(function() {
    const url = $(this).parent().attr('data-url');
    //console.log(url);
    socialShare('http://www.facebook.com/sharer.php?s=100&p[url]=' + url, 580, 350);
  });

  $('.sendtoGplus').click(function() {
    const url = $(this).parent().attr('data-url');
    socialShare('https://plus.google.com/share?url=' + url + '#sthash.5oAD34pj.dpuf', 580, 350);
  });

  $('.sendtoTwitter').click(function() {
    var url = $(this).parent().attr('data-url');
    socialShare('https://twitter.com/home?status=' + url, 580, 350);
  });

  $('.sendtoWhatsapp').click(function() {
    const url = $(this).parent().attr('data-url');
    socialShare('whatsapp://send?text=' + url, 580, 350);
  });

  // if (false && window.location.hostname === 'www.gsp.ro') {
  //   window.OneSignal = window.OneSignal || [];
  //   OneSignal.push(function () {
  //     OneSignal.init({
  //       appId: '0de21190-e4f9-44c7-8bd4-f856d90d68ce',
  //     });
  //   });
  //   window.setTimeout(function () {
  //     $.getScript('https://cdn.onesignal.com/sdks/OneSignalSDK.js');
  //   }, 20000);
  // }
});

function furthest(node, s) {
  var el = node.parentElement || node.parentNode;
  var anc = null;

  while (el !== null && el.nodeType === 1) {
    if (el.matches(s)) {
      anc = el;
    }
    el = el.parentElement || el.parentNode;
  }
  return anc;
}

function sendCoteAnalytics() {
  $('.widget-odds .odds-provider').map(function(key, item) {
    var widgetType = $(furthest(item, '[data-widgetId]')).data('widgetid');
    var bookmaker = item.title;
    if (widgetType === 'widget-match') {
      var checkCoteParent = $(item).closest('div.widget-tabs-lined').length;
      if (checkCoteParent === 1) {
        widgetType = 'widget-match-tab-cote';
      }
    }

    if (widgetType === 'odds-listing') {
      var options = $(furthest(item, '[data-widgetId]')).data('options');
      if (options && options.displayMatchHeader === false) {
        widgetType = 'odds-listing-single';
      }
    }
    if (typeof item.dataset.gasent === 'undefined') {
      //           debugger
      console.log(widgetType, bookmaker);
      ga('send', 'event', 'stats-bookmaker', bookmaker, widgetType, {
        nonInteraction: true
      });
    }

    if (item) {
      item.dataset.gasent = 1;
    }
  });
}

_gspQ.push(function() {
  // setTimeout(function () {
  //     $('[data-widgetId]').each(function (key, item) {
  //         $item = $(item);
  //         if ($item.html() > ' ') {
  //             var widgetId = $item.data('widgetid');
  //             if (widgetId === 'odds-listing' && $item.data('options') && $item.data('options').displayMatchHeader === true) {
  //                 widgetId = 'odds-listing-comparision';
  //             }
  //             if (widgetId && $item.data('options') && $item.data('options').eventId) {
  //                 ga('send', 'event', 'widgetid', widgetId, $item.data('options').eventId, {
  //                     nonInteraction: true,
  //                 });
  //             }
  //         }
  //     });
  // }, 5000);
  // setTimeout(function () {
  //     console.log($('.widget-odds .odds-provider').map(function (k, item) {
  //         return item.title;
  //     }));
  //     sendCoteAnalytics();
  //     $('.widget.widget-tabs-lined a:contains("COTE")').on('click', function () {
  //         sendCoteAnalytics();
  //     });
  // }, 3000);

  // setTimeout(function () {
  //     $('[data-widgetId]')
  //         .filter(function (key, item) {
  //             var $item = $(item);
  //             return $item.data('options');
  //         })
  //         .each(function (key, item) {
  //             var $item = $(item);
  //             var widgetId = $item.data('widgetid');
  //             if (widgetId) {
  //                 if (widgetId === 'odds-listing' && $item.data('options') && $item.data('options').displayMatchHeader === true) {
  //                     widgetId = 'odds-listing-comparision';
  //                 }
  //
  //                 //                console.log($item.data());
  //                 var options = $item.data('options') || {};
  //                 if (options.oddProviderIds && options.oddProviderIds.length) {
  //                     options.oddProviderIds.forEach(function (item, key) {
  //                         ga('send', 'event', 'bookmaker', item, widgetId, {
  //                             nonInteraction: true,
  //                         });
  //                     });
  //                 }
  //                 if (widgetId === 'widget-match') {
  //                     ga('send', 'event', 'bookmaker', options.mainOddProvider, widgetId + '-main', {
  //                         nonInteraction: true,
  //                     });
  //                 }
  //             }
  //         });
  // }, 5000);
});


// document.addEventListener('scroll', function () {
//   var h = document.documentElement,
//     b = document.body,
//     st = 'scrollTop',
//     sh = 'scrollHeight';
//
//   var percent = parseInt(
//     ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100
//   );
//
//   if (percent === 25) {
//     ga('send', 'event', 'scrolling', 'moreThan25%', window.location.pathname, {
//       nonInteraction: true,
//     });
//   } else if (percent === 50) {
//     ga('send', 'event', 'scrolling', 'moreThan50%', window.location.pathname, {
//       nonInteraction: true,
//     });
//   } else if (percent === 75) {
//     ga('send', 'event', 'scrolling', 'moreThan75%', window.location.pathname, {
//       nonInteraction: true,
//     });
//   } else if (percent === 90) {
//     ga('send', 'event', 'scrolling', 'moreThan90%', window.location.pathname, {
//       nonInteraction: true,
//     });
//   }
// });


document.addEventListener('DOMContentLoaded', function() {
  console.log('Init _gspQ DomContentLoaded');
  _gspQ.push = function(item) {
    item();
  };
  if (_gspQ.length > 0) {
    console.log('Init _gspQ DomContentLoaded found ' + _gspQ.length + ' items');
    _gspQ.map(function(item) {
      item();
    });
    // _gspQ = [];
    _gspQ.length = 0;
  } else {
    console.log('No _gspQ entries');
  }

});

// import 'owl.carousel/dist/assets/owl.carousel.css';
// import 'owl.carousel/dist/assets/owl.theme.default.css';
// import('owl.carousel');
// let owl;
window.owl = null;
window.enableBlogSportSlidesInit = null;
window.enableBlogSportSlides = function() {
  if (window.enableBlogSportSlidesInit === null) {
    window.enableBlogSportSlidesInit = 1;
    if (window.innerWidth > 1280) {
      $.getScript('/plugins/owl.carousel.min.js', function() {
        $('.blogsport-container').addClass('owl-carousel');
        setTimeout(function() {
          window.owl = $('.blogsport-container').owlCarousel({
            loop: true, checkVisible: false, dots: false, margin: 20, items: 4, nav: false
          });
          $('.prev-next:first').on('click', function(event) {
            console.log(event);
            console.log('Going 4 times prev');
            event.preventDefault();
            window.owl.trigger('prev.owl');
            window.owl.trigger('prev.owl');
            window.owl.trigger('prev.owl');
            window.owl.trigger('prev.owl');
          });

          $('.prev-next:not(:first)').on('click', function(event) {
            console.log(event);
            console.log('Going 4 times next');
            event.preventDefault();
            window.owl.trigger('next.owl');
            window.owl.trigger('next.owl');
            window.owl.trigger('next.owl');
            window.owl.trigger('next.owl');
          });
        }, 1);
      });
    }
  }
};
// import { tns } from 'tiny-slider/src/tiny-slider';
//
// var slider = tns({
//   container: '.blogsport-container',
//   items: 4,
//   slideBy: 'page',
//   autoplay: false,
// });

window.changeDarkTheme = function() {
  var htmlTag = document.getElementsByTagName('html')[0];
  var isDarkModePrefered = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  if (htmlTag.getAttribute('data-theme')) {
    htmlTag.setAttribute('data-theme', '');
    deleteCookie('theme-preferred');
    return;
  }

  setCookie('theme-preferred', isDarkModePrefered ? 'light' : 'dark', 365);
  //set the opposite of what knows
  htmlTag.setAttribute('data-theme', isDarkModePrefered ? 'light' : 'dark');
};

function setCookie(name, value, days) {
  var expires = '';
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
}

function getCookie(name) {
  var nameEQ = name + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function eraseCookie(name) {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

window.eventsData = function() {
  let articlesEvents = [];
  let articlesOdds = [];
  $('.news-item')
    .filter(function(index, el) {
      return $(el).data('eventId');
    })
    .each(function(index) {
      eventId = $(this).data('eventId');
      oddId = $(this).data('oddProviderId');
      started = $(this).data('s');
      if (eventId) {
        articlesOdds.push({
          eventId: eventId, oddId: oddId
        });
        if (started) {
          articlesEvents.push({
            eventId: eventId, oddId: oddId
          });
        }
      }
    });

  if (articlesOdds.length) {
    $.ajaxSetup({
      headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') }
    });
    $.ajax({
      method: 'POST', url: '/index.php?section=smp&screen=articles_odds', data: { articlesOdds: articlesOdds }
    }).done(function(result) {
      data = jQuery.parseJSON(result);
      $.each(data, function(key, value) {
        $elem = $('.news-item[data-id=\'' + this.id + '\'] .rezultat-atasat');
        if ($elem && this.html) {
          if ($elem.children().last().hasClass('pariu')) {
            $elem.children().last().remove();
          }
          $elem.children().last().after(this.html);
          $elem.addClass('rezultat-atasat--cu-cote');
        }
      });
    });
  }

  if (articlesEvents.length) {
    $.ajax({
      method: 'POST', url: '/index.php?section=smp&screen=article_event', data: { articlesEvents: articlesEvents }
    }).done(function(result) {
      data = jQuery.parseJSON(result);
      $.each(data, function(key, value) {
        $elem = $('.news-item[data-event-id=\'' + key + '\'] .rezultat-atasat__link');
        if ($elem && value) {
          $elem.replaceWith(value);
        }
      });
    });
  }
};
_gspQ.push(function() {
  eventsData();
});

_gspQ.push(function() {
  $('#v-popup .close').on('click', function(ev) {
    ev.preventDefault();
    const videoLiveId = document.getElementById('v-popup').dataset.videoId;
    window.trackGtmEvent('banda_video_remove', 'BandaVideo', 'id-' + videoLiveId);
    document.body.classList.remove('banda-live-video-on');
    $(this).parent().css('display', 'none');
    if (!getCookie('liveVideoClosed')) {
      setCookie('liveVideoClosed', 1, 1 / 12);
    }
    return false;
  });
});

document.addEventListener('click', function(e) {
  const popup = e.target.closest('.v-popup');
  if (!popup) return;

  const link = e.target.closest('a[href]');
  if (!link) return;

  const href = link.getAttribute('href') || '';
  if (!href.includes('video.gsp.ro')) return;

  const videoId = popup.dataset.videoId || 'unknown';
  if (window.trackGtmEvent) {
    window.trackGtmEvent('banda_video_play', 'BandaVideo', 'id-' + videoId);
  }
}, true);


window.showLoginCard = function() {
  let s = 'card-general-v1';
  let metaArticleId = $('meta[name=articleId]');
  let pianoLoginUrl = 'https://www.gsp.ro/cont/login?source=gsp-widget-' + metaArticleId.attr('content') + '-' + s + '&state=article';
  let html = '<div class="login-card__titlu">Conectează-te cu <span class="red-highlight">GSP.ro</span>!</div><p>Înregistrează-te sau intră în contul tău pentru a fi parte din comunitatea noastră și pentru a accesa beneficiile.</p><div class="login-card__icons"><img src="/images/login-card-icon-1.svg"><img src="/images/login-card-icon-2.svg"><img src="/images/login-card-icon-3.svg"><img src="/images/login-card-icon-4.svg"></div><ul><li>Ai o <strong>experiență personalizată</strong>, în funcție de preferințe</li><li>Poți intra în <strong>conversație</strong> prin intermediul comentariilor</li><li>Participi la <strong>concursuri</strong> cu premii spectaculoase</li><li>Ai acces la <strong>newslettere</strong> și <strong>recomandări</strong> personale</li><li><strong class="red-highlight">TOTUL E 100% GRATUIT</strong></li></ul><a href="' + pianoLoginUrl + '" class="login-card__buton">Intră în cont</a><a href="javascript:hideLoginCard();void(0);" class="login-card__buton login-card__buton--secondary">Continuă fără cont</a><a href="' + pianoLoginUrl + '" class="login-card__ghost"></a>';
  let loginCard = $('.login-card');
  loginCard.addClass('login-card--blocker').html(html);
  loginCard.attr('card-type', s);
  $('.article-body-container').addClass('needs-login');
  window.tr('pianoCard', 'show', metaArticleId.attr('content'), { 'type': 'card-general-v1' });
};

window.hideLoginCard = function() {
  $('.article-body-container').removeClass('needs-login');
  window.tr('pianoCard', 'hide', $('meta[name=articleId]').attr('content'), { 'type': $('.login-card').attr('card-type') });
  return false;
};

window.showCommentsLoginCard = function() {
  pianoCommentsLoginUrl = 'https://www.gsp.ro/cont/login?source=gsp-widget-' + $('meta[name=articleId]').attr('content') + '-card-comment-v1&state=article';
  commentsLoginCardHtml = '<div class="login-card__icons">\n' + '<img src="/images/login-card-icon-2.svg">\n' + '</div>\n' + '<div class="login-card__titlu">Care e opinia ta?</div>\n' + '<p>Lasă-ne un comentariu după ce citești acest articol.</p>\n' + '<p class="login-card__fine-print">Fii parte din comunitatea noastră ca să poți posta comentarii și să accesezi multe alte beneficii.</p>\n' + '<a href="' + pianoCommentsLoginUrl + '" class="login-card__buton">Intră în cont ca să poți comenta</a>\n' + '<a href="javascript:hideLoginCard();void(0);" class="login-card__buton login-card__buton--secondary">Continuă fără cont</a>\n' + '<a href="' + pianoCommentsLoginUrl + '" class="login-card__ghost"></a>\n';

  $('.login-card').addClass('login-card--blocker login-card--comentarii').html(commentsLoginCardHtml);
  $('.article-body-container').addClass('needs-login');
  window.tr('pianoCard', 'show', $('meta[name=articleId]').attr('content'), { 'type': 'card-comment-v1' });
};


function goBackAndForth(entry) {
  console.log('%% Wait for 3 seconds', new Date());
  setTimeout(() => {
    console.log('% Scroll to right', new Date());
    entry.target.scrollBy({
      left: entry.target.scrollWidth - entry.target.clientWidth,
      top: 0,
      behavior: 'smooth'
    });
  }, 1.5 * 1000);
  setTimeout(() => {
    console.log('%% Scroll to left', new Date());
    entry.target.scrollBy({
      left: -(entry.target.scrollWidth - entry.target.clientWidth),
      top: 0,
      behavior: 'smooth'
    });
  }, 6 * 1000);
}

_gspQ.push(function() {
  // debugger
  console.log('%% Setup partners carousel');
  const observer = new IntersectionObserver((entries) => {
    console.log('%% Enter observer');
    entries.forEach(entry => {
      if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
        console.log('%% Launch scrollBy');
        if (window.carouselInt) {
          clearInterval(window.carouselInt);
        }
        setTimeout(() => {
          goBackAndForth(entry);
          window.carouselInt = window.setInterval(() => {
            goBackAndForth(entry);
          }, 7 * 1000);
        }, 3 * 1000);

      }
    });
  }, { threshold: 0.6 });

  const elements = document.querySelectorAll('section .partners-carousel.partners');
  if (elements && elements.length) {
    elements.forEach(element => {
      // debugger
      observer.observe(element);
    });
  }
});


document.addEventListener('DOMContentLoaded', function() {
  const targetElement = document.getElementById('stats-schedule-hp');
  const pageLoadTime = performance.now();

  if (targetElement) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          const secondsSincePageOpened = ((performance.now() - pageLoadTime) / 1000).toFixed(2);

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'widget_hp_visible',
            'event_category': 'WidgetHp',
            'value': secondsSincePageOpened
          });

          // Stop observing after the first event is sent
          observer.unobserve(targetElement);
        }
      });
    }, {
      threshold: 0.5
    });

    observer.observe(targetElement);
  }

});


function wrapHyphenWords(rootElement, excludedSelectors = []) {
  const treeWalker = document.createTreeWalker(
    rootElement,
    NodeFilter.SHOW_TEXT,
    {
      acceptNode: function(node) {
        if (!node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        if (node.parentNode.closest('.bug-cratima')) return NodeFilter.FILTER_REJECT;
        for (const sel of excludedSelectors) {
          if (node.parentNode.closest(sel)) return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    }
  );

  // A–Z + a–z + ăâîșțĂÂÎȘȚ + cifre
  const charGroup = 'a-zA-Z0-9ăâîșşțţĂÂÎȘŞȚŢ';
  const wordWithHyphen = `[${charGroup}]+-[${charGroup}]+`;
  // const wordWithHyphen = `[\\p{L}\\d]+-[\\p{L}\\d]+`;

  // Include semne de punctuație la început și sfârșit (dacă sunt)
  const punctStart = `[„“"«»()\\-–—…]*`;
  const punctEnd = `[.,!?;:“”"»«()\\-–—…]*`;


  const regex = new RegExp(`(${punctStart}${wordWithHyphen}${punctEnd})`, 'gu');

  let currentNode;

  while (currentNode = treeWalker.nextNode()) {
    const parent = currentNode.parentNode;
    const originalText = currentNode.nodeValue;

    if (!regex.test(originalText)) continue;
    regex.lastIndex = 0;

    const wrapper = document.createElement('span');
    wrapper.innerHTML = originalText.replace(regex, (match) => {
      return `<span class="bug-cratima">${match}</span>`;
    });

    while (wrapper.firstChild) {
      parent.insertBefore(wrapper.firstChild, currentNode);
    }
    parent.removeChild(currentNode);
  }
}

function wrapHyphenWordsInNewsItems() {
  const newsItems = document.querySelectorAll('.news-item');
  newsItems.forEach(item => wrapHyphenWords(item));
}

document.addEventListener('DOMContentLoaded', () => {
  wrapHyphenWordsInNewsItems();
});

(function() {
  const section = document.querySelector('section.topstory--video-rectangle');
  if (!section) return;

  const safeTrack = (event, category, label) => {
    try {
      window.trackGtmEvent?.(event, category, label);
    } catch {
    }
  };

  // 1. Rendered
  safeTrack('calup_video_rendered', 'VideoBySuperliga', 'rendered');

  // 2. Viewed (50% or more visible)
  const observer = new IntersectionObserver(
    (entries, obs) => {
      for (const entry of entries) {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          safeTrack('calup_video_viewed', 'VideoBySuperliga', 'viewed');
          obs.disconnect();
          break;
        }
      }
    },
    { threshold: [0.5] }
  );
  observer.observe(section);

  // 3. Click tracking — only links inside this section
  section.addEventListener('click', e => {
    const link = e.target.closest('a.topstory__item');
    if (!link || !section.contains(link)) return; // ensures click inside this section only

    const href = link.getAttribute('href') || '';
    const id = href.split('/').pop()?.replace('.html', '').split('-').pop();

    if (id) safeTrack('calup_video_click', 'VideoBySuperliga', 'id-' + id);
  });
})();



document.addEventListener("DOMContentLoaded", () => {
  const targets = document.querySelectorAll('[data-lazy-load="1"]');
  if (!targets.length) return;

  console.log("[ads] lazy init", targets.length);

  const observer = new IntersectionObserver((entries, obs) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;

      const el = entry.target;
      console.log("[ads] Loading slot:", el.id);

      googletag.cmd.push(() => {
        const slot = googletag.pubads().getSlots().find(
          s => s.getSlotElementId() === el.id
        );
        if (slot) {
          googletag.pubads().refresh([slot]);
        }
      });

      obs.unobserve(el);
    }
  }, {
    rootMargin: "200px 0px",
    threshold: 0.01
  });

  targets.forEach(t => observer.observe(t));
});
